import { render, staticRenderFns } from "./viewImage.vue?vue&type=template&id=c740b36e&scoped=true&"
import script from "./viewImage.vue?vue&type=script&lang=js&"
export * from "./viewImage.vue?vue&type=script&lang=js&"
import style0 from "./viewImage.vue?vue&type=style&index=0&id=c740b36e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c740b36e",
  null
  
)

export default component.exports